var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"composer-tabs"},[_vm._t("default",null,{"toggle":_vm.toggle,"active":_vm.active}),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_vm._t("items",null,{"active":_vm.active})],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0393266c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/composer/Tabs/Tabs.vue
// module id = null
// module chunks = 